import React, { useState } from "react";
import { Col, Container, Row, Progress, Button, Input } from "reactstrap";
import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import {Footer} from "./Footer";

function FunctionalCounterProgressBar() {
  //define state variables
  const [count, setCount] = useState(0);
  console.log("Count:", count);

  //Increment function
  const Increment = () => {
    if (count < 100) {
      setCount(count + 1);
    }
  };

  //Decrement function
  const Decrement = () => {
    if (count > 0) {
      setCount(count - 1);
    }
  };

  //function handle input field change
  const handleInputChange = (e) => {
    const value = e.target.value === "" ? "" : Number(e.target.value);
    console.log(value);

    if (value === "" || (value >= 0 && value <= 100)) {
      setCount(value);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center text-center bg-custom vh-100">
      <Container fluid>
        <Row className="justify-content-center">
          <h1 className="mt-2">React Progress Bar</h1>
          <Col sm="9" md="6" lg="6">
            <Progress
              color="blue"
              className="my-4 custom-progress rounded-pill"
              value={count}
            >
              {count} %
            </Progress>
          </Col>
        </Row>
        <div className="d-flex justify-content-center text-center mt-4">
          <Col sm="9">
            <Row xs={3} className="justify-content-center">
              <Col className="text-end">
                <Button
                  className="bg-light text-dark border-0 custom-btn rounded-circle me-5"
                  size="sm"
                  onClick={Decrement}
                >
                  <FaMinus />
                </Button>
              </Col>
              <Col sm="2" md="3" lg="2">
                <Input
                  type="number"
                  className="custom-form text-center mx-auto"
                  max="100"
                  maxLength="3"
                  onChange={handleInputChange}
                  value={count}
                />
              </Col>
              <Col className="text-start">
                <Button
                  className="bg-light text-dark border-0 custom-btn rounded-circle mx-5"
                  size="sm"
                  onClick={Increment}
                >
                  <FaPlus />
                </Button>
              </Col>
            </Row>
          </Col>
        </div>
        <Footer />
      </Container>
    </div>
  );
}

export default FunctionalCounterProgressBar;
